export const EMAIL_REG_EXP = /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/
